(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectTypeService', projectTypeService);

	projectTypeService.$inject = ['$http', 'URLS'];

	function projectTypeService($http, URLS) {
		var service = {
			getProjectTypes: getProjectTypes,
			addProjectType: addProjectType,
			updateProjectType: updateProjectType,
			deleteProjectType: deleteProjectType
		};
		return service;

		function getProjectTypes(siteId) {
			var projectTypeCrudUrl = URLS.host + String.format(URLS.projectTypeCrud, siteId || globalConfig.factory.id);
			return $http.get(projectTypeCrudUrl)
				.then(getProjectTypesSuccess, handleError);

			function getProjectTypesSuccess(response) {
				return response.data;
			}
		}

		function addProjectType(projectType, siteId) {
			var projectTypeCrudUrl = URLS.host + String.format(URLS.projectTypeCrud, siteId || globalConfig.factory.id);

			return $http.post(projectTypeCrudUrl, projectType)
				.then(addProjectTypeSuccess, handleError);

			function addProjectTypeSuccess(response) {
				return 'Project type created successfully';
			}
		}

		function updateProjectType(projectType, lastModified, siteId) {
			var projectTypeCrudUrl = URLS.host + String.format(URLS.projectTypeCrud, siteId || globalConfig.factory.id);
			return $http.put(projectTypeCrudUrl + '/' + projectType.id, projectType, { headers: { 'If-Unmodified-Since': lastModified } })
				.then(updateProjectTypeSuccess, handleError);

			function updateProjectTypeSuccess(response) {
				return response;
			}
		}

		function deleteProjectType(projectTypeId, newProjectTypeId, siteId) {
			var projectTypeCrudUrl = URLS.host + String.format(URLS.projectTypeCrud, siteId || globalConfig.factory.id) + '/' + projectTypeId;
			if (newProjectTypeId) {
				projectTypeCrudUrl += '?newProjectTypeId=' + newProjectTypeId;
			}
			return $http.delete(projectTypeCrudUrl)
				.then(deleteGoalSuccess, handleError);

			function deleteGoalSuccess(response) {
				return 'Project Type deleted successfully';
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
